module.exports = __webpack_public_path__ + "static/img/goods-small-bg.2fea8c6a.png";